"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ILULeadsDashboardFilterDto {
}
exports.ILULeadsDashboardFilterDto = ILULeadsDashboardFilterDto;
